export const actionTypes = {
    GET_CATEGORIES: 'GET_CATEGORIES',
    GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
    GET_CATEGORIES_FAILED: 'GET_CATEGORIES_FAILED',

    POST_CATEGORY: 'POST_CATEGORY',
    POST_CATEGORY_SUCCESS: 'POST_CATEGORY_SUCCESS',
    POST_CATEGORY_FAILED: 'POST_CATEGORY_FAILED',

    GET_CATEGORY: 'GET_CATEGORY',
    GET_CATEGORY_SUCCESS: 'GET_CATEGORY_SUCCESS',
    GET_CATEGORY_FAILED: 'GET_CATEGORY_FAILED',

    PATCH_CATEGORY: 'PATCH_CATEGORY',
    PATCH_CATEGORY_SUCCESS: 'PATCH_CATEGORY_SUCCESS',
    PATCH_CATEGORY_FAILED: 'PATCH_CATEGORY_FAILED',

    DELETE_CATEGORY: 'DELETE_CATEGORY',
    DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
    DELETE_CATEGORY_FAILED: 'DELETE_CATEGORY_FAILED',

    CLEAR_STATE: 'CLEAR_STATE'
};
export default actionTypes;
